import React from "react";
import { Input } from "antd";

const MetricsCustomInput = ({
  width,
  height,
  border,
  bgColor,
  textColor,
  borderRadius,
  placeholderColor,
  lineHeight,
  type = "text",
  suffix,
  prefix,
  boxShadow,
  disabled,
  children,
  value,
  ...props
}) => {
  const customStyle = {
    height: height || "36px",
    width: width || "100%",
    border: border || "none",
    backgroundColor: bgColor || "#F3F3F3",
    color: textColor || "#000000",
    borderRadius: borderRadius || "8px",
    lineHeight: lineHeight || "normal",
    boxShadow: boxShadow || "none",
    // fontSize : '12px',
  };

  const placeholderStyle = {
    "::placeholder": {
      color: placeholderColor || "#5E5E5E",
    },
  };

  return (
    <div style={{ ...customStyle, ...placeholderStyle, border: "0" }}>
      {children ? (
        children
      ) : (
        <Input
          style={{ ...customStyle, ...placeholderStyle }}
          suffix={<span style={{ color: '#000', fontWeight:'600', fontSize:'12px', lineHeight:'16px' }}>{suffix}</span>}
          prefix={prefix}
          disabled={disabled}
          value={value}
          {...props}
        />
      )}
    </div>
  );
};

export default MetricsCustomInput;
